export default __webpack_public_path__ + "static/implied-motion-dark-757de2f6dd7298ac9516f682bc7739b57dd85b6a8be03c7ceaadad9d9de3f81b.mp4";